import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const disposeAreaRoutes: RouteRecordRaw[] = [
  {
    path: '/dispose-area',
    name: 'dispose-area',
    component: () => import('./views/DisposeAreaView.vue'),
    meta: {
      title: () => i18next.t('nav.disposeArea'),
      requiredAnyEntitlement: [
        'INVENTORY',
        'MILK_MANAGEMENT',
        'feed.feed_prep_full',
        'feed.feed_prep_donor_only',
        'feed.feed_prep_product',
        'feed.feed_prep_donor_mother',
      ],
      breadcrumbs: [{ label: () => i18next.t('nav.disposeArea') }],
    },
  },
];
